export default "__VITE_ASSET__6d73c204__"